<aside class="sidebar" [class.closed]="!isOpen()" [class.hidden]="sidebarService.isFilterMenuOpen()">
    <div class="sidebar-header">
        <button class="close-button" aria-label="Close" (click)="closeSidebar()">&#x2715;</button>
    </div>

    <div class="sidebar-logo-container">
        <img src="assets/logos/logo_proyecto_ayuntamiento.svg" alt="Logo Proyecto" class="sidebar-logo">
    </div>

    <nav class="sidebar-nav">
        <ul>
            @for (link of links; track $index) {
            <li>
                @if (link.linkID === 4) {
                <!-- Submenu desplegable -->
                <div class="link-with-submenu">
                    <a class="link" (click)="toggleSubMenu()">
                        <p class="link-title">{{ link.title | translate }}</p>
                        <p class="link-subtitle">{{ link.subtitle | translate }}</p>
                        <span class="dropdown-icon" [class.rotated]="isSubMenuOpen()">▼</span>
                    </a>

                    <ul class="submenu" [class.open]="isSubMenuOpen()">
                        @for (sublink of sublinks; track sublink.subLinkID) {
                        <li>
                            <a [routerLink]="sublink.url"
                                [queryParams]="sublink.categoryCode ? {category: sublink.categoryCode} : {}"
                                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sublink"
                                (click)="closeSidebar()">
                                <p class="link-title">{{ sublink.title | translate }}</p>
                            </a>
                        </li>
                        }
                    </ul>
                </div>
                } @else {
                <a [routerLink]="link.url" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                    class="link" (click)="closeSidebar()">
                    <p class="link-title">{{ link.title | translate }}</p>
                    <p class="link-subtitle">{{ link.subtitle | translate }}</p>
                </a>
                }
            </li>
            }
        </ul>
    </nav>

    <div class="sidebar-language" (click)="toggleLanguage()">
        <span class="language-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                </path>
            </svg>
        </span>
        <strong [class.active-lang]="currentLang === 'es'">ES</strong>
        <span class="lang-separator">/</span>
        <strong [class.active-lang]="currentLang === 'en'">EN</strong>
    </div>
</aside>